export default class PageFollow {
  constructor() {
    this.stickyClass = 'is-sticky';
    this.breakpointQuery = window.matchMedia('(min-width: 768px)');
    this.areaSelector = '.js-follow_area';
    this.triggerSelector = '.js-follow_trigger';
    this.placeholderClass = 'js-follow_placeholder';
    this.tolerance = 1; //スクロール判定のバッファの値
    this.items = [];
    this.isTicking = false;

    this.collectItems();
    if(this.items.length === 0) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.init();
  }

  isPcLayout() {
    return this.breakpointQuery.matches;
  }

  collectItems() {
    document.querySelectorAll(this.areaSelector).forEach((area) => {
      const trigger = area.querySelector(this.triggerSelector);
      if(!trigger) {
        return;
      }

      const placeholder = document.createElement('div');
      placeholder.className = this.placeholderClass;
      placeholder.setAttribute('aria-hidden', 'true');
      trigger.insertAdjacentElement('afterend', placeholder);

      this.items.push({
        area,
        trigger,
        placeholder,
        isSticky: false,
      });
    });
  }

  init() {
    this.setPlaceholderHeight();
    this.update();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.setPlaceholderHeight();
        this.update();
      });

      this.items.forEach(({ area }) => {
        this.resizeObserver.observe(area);
      });
    }
  }

  onScroll() {
    if(this.isTicking) {
      return;
    }

    this.isTicking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.isTicking = false;
    });
  }

  onResize() {
    this.setPlaceholderHeight();
    this.update();
  }

  // SPではnavをfixedで固定するため、追従中に抜けるナビ分の高さをプレースホルダーで確保しています
  setPlaceholderHeight() {
    this.items.forEach((item) => {
      const height = item.trigger.offsetHeight;
      if(this.isPcLayout() || !item.isSticky) {
        return;
      }
      item.placeholder.style.height = `${height}px`;
    });
  }

  update() {
    this.items.forEach((item) => {
      //追従すべきか判定
      const isSticky = this.shouldBeSticky(item);
      if(item.isSticky === isSticky) {
        return;
      }
      this.applyStickyState(item, isSticky);
    });
  }

  shouldBeSticky(item) {
    const areaRect = item.area.getBoundingClientRect();

    if(this.isPcLayout()) {
      const triggerRect = item.trigger.getBoundingClientRect();
      const { top } = getComputedStyle(item.trigger);
      const stickyTop = top === 'auto' ? 0 : parseFloat(top) || 0; // stickyの付着位置

      return (
        //ナビの上端が画面の上端まで来ている
        triggerRect.top <= stickyTop + this.tolerance &&
        //かつ、追従エリアの途中にいる場合true
        areaRect.bottom > triggerRect.bottom + this.tolerance
      );
    }

    return (
      //追従エリアの上端が、画面の上端まで来ている
      areaRect.top <= this.tolerance &&
      //かつ、追従エリアの途中にいる場合true
      areaRect.bottom > window.innerHeight + this.tolerance
    );
  }

  applyStickyState(item, isSticky) {
    if(this.isPcLayout()) {
      //PCはstickyで追従するのでplaceholderは使わない = 高さ0
      item.placeholder.style.height = '0';
      item.isSticky = isSticky;
      item.trigger.classList.toggle(this.stickyClass, isSticky);
      return;
    }

    if(isSticky) {
      item.placeholder.style.height = `${item.trigger.offsetHeight}px`;
      item.isSticky = true;
      item.trigger.classList.add(this.stickyClass);
      return;
    }

    item.isSticky = false;
    item.trigger.classList.remove(this.stickyClass);
    item.placeholder.style.height = '0';
  }

}
